// Youtube API script URL
export var YOUTUBE_SCRIPT_URL = 'https://www.youtube.com/iframe_api'; // Custom events

export var PLAY_VIDEO_EVENT = 'PlayVideo'; // Privacy settings

export var USER_PRIVACY = {
  ANALYTICS_ENABLED: 'userPrivacy_AnalyticsEnabled',
  FUNCTIONAL_ENABLED: 'userPrivacy_FunctionalEnabled',
  TARGETING_ENABLED: 'userPrivacy_TargetingEnabled'
};